export default "__VITE_ASSET__CTmZ6Rf0__"